// plugins/html2canvas.client.ts - Note the .client to ensure it only runs in the browser
import html2canvas from 'html2canvas';

export default defineNuxtPlugin(() => {
    return {
        provide: {
            html2canvas
        }
    };
});
